module.exports = __webpack_public_path__ + "img/hand-paper.3903337b.svg";